<script lang="ts">
  import { onMount } from "svelte";
  import { setHeadTitle } from "../app/store/store-ui";
  import Header from "../components/header/Header.svelte";
  import Splash from "../components/splash/Splash.svelte";
  import WaitlistFooter from "../components/footer/waitlist/WaitlistFooter.svelte";
  import MainFooter from "../components/footer/main-footer/MainFooter.svelte";
  import checkMobileDevice from "../components/common/is-mobile";

  const isMobile = checkMobileDevice();
  let isSliderImageLoaded: boolean = false;
  let element: HTMLElement;
  let isHeaderActive: boolean = false;
  const headerActiveScrollThreshhold = -30;

  function handleImageLoaded() {
    isSliderImageLoaded = true;
  }

  function loadImage() {
    // this image is quite big, preload it to make sure it will be fetched before showing the page
    const img = new Image();
    img.addEventListener("load", handleImageLoaded);
    img.src = "/images/splash/splash-excel.png";
  }

  loadImage();

  function handlePagePositionChange() {
    isHeaderActive =
      element.getBoundingClientRect().top < headerActiveScrollThreshhold;
  }

  onMount(() => {
    setHeadTitle("");
    document.body.addEventListener("scroll", handlePagePositionChange);
    return () => {
      document.body.removeEventListener("scroll", handlePagePositionChange);
    };
  });
</script>

<div bind:this={element} class="page-wrapper" class:mobile={isMobile}>
  <Header isActive={isHeaderActive} />

  <div class:hidden={!isSliderImageLoaded}>
    <Splash isImageReady={isSliderImageLoaded} />
    <WaitlistFooter />
    <MainFooter />
  </div>
</div>

<style lang="postcss">
  .page-wrapper {
    position: relative;
  }

  .page-wrapper::before {
    @apply absolute top-0 left-0 right-0;
    content: "";
    height: 810px;
    z-index: -1;
    background: linear-gradient(
      180deg,
      rgba(59, 199, 255, 0.1) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  .page-wrapper.mobile::before {
    height: 580px;
  }
</style>
